export default {
  meta: {
    title: '广告位详情'
  }
};
